import {} from "@mui/material";
import type React from "react";
import type { MasterDataVehicleDetailPageProps } from "../model";
import { MasterDataVehicleDetailInProgress } from "./in-progress";
import { MasterDataVehicleDetailPreview } from "./preview";

export const MasterDataVehicleDetailPageUi: React.FC<
  MasterDataVehicleDetailPageProps
> = (props) => {
  if (props.previewValues) {
    return <MasterDataVehicleDetailPreview {...props} />;
  }
  return <MasterDataVehicleDetailInProgress {...props} />;
};
